export interface GetReserveSetReserveRequest {
  userId: string
  reserveSetId: number
}

export function GetReserveSetReserveRequestToJSON(
  value: GetReserveSetReserveRequest
): any {
  return {
    user_id: value.userId !== '' ? value.userId : undefined,
    reserve_set_id: value.reserveSetId !== 0 ? value.reserveSetId : undefined
  }
}
